import { makeAutoObservable } from "mobx";

class UserStore {
  constructor() {
    makeAutoObservable(this);
  }

  token: string = null;

  userOrganizationId: string = null;

  setUserOrganizationId = (userOrganizationId: string) => {
    this.userOrganizationId = userOrganizationId;
  };

  setToken = (token: string) => {
    this.token = token;
  };
}

export default UserStore;
